import * as React from 'react';
import Async from 'react-select/lib/Async';
import { Translate } from '../../../../../../shared/LanguageService';
import Api from './Api';
import SwapSearchResultItem from './SearchResultItem';

interface IProps {
    selected: (e: any) => void;
}

interface IState {}

class SwapSearchForm extends React.Component<IProps, IState> {
    constructor(props: any, context: any) {
        super(props, context);

        this.loadSearchResults = this.loadSearchResults.bind(this);
    }

    displayLegacyOrderNumber(order): string {
        if (
            order.legacyOrderNumber != null &&
            order.orderNumber.indexOf(order.legacyOrderNumber) === -1
        ) {
            return ` (${order.legacyOrderNumber})`;
        }
        return '';
    }

    loadSearchResults(input, callback): any {
        if (!input || input.length < 3) {
            callback([]);
        }

        Api.search(input)
            .then((result) => {
                let orders = result.orders.map((order) => {
                    return {
                        label:
                            `${order.orderNumber}${this.displayLegacyOrderNumber(order)}` +
                            (order.address ? ` - ${order.address}` : ''),
                        value: order.id,
                        title: Translate('order/plan/swap/search/placed-by', {
                            brokerFirm: order.brokerFirm
                        })
                    };
                });

                callback([...orders]);
            })
            .catch((error) => callback(error, null));
    }

    render(): JSX.Element {
        return (
            <div className="search-form super-search">
                <Async
                    placeholder={Translate('header/nav/search')}
                    searchPromptText=""
                    clearable={true}
                    autoFocus={true}
                    autoload={false}
                    ignoreAccents={false}
                    ignoreCase={false}
                    cache={false}
                    filterOptions={(options) => options /* disables internal filtering */}
                    components={{ Option: SwapSearchResultItem }}
                    onChange={(e) => this.props.selected(e)}
                    loadOptions={this.loadSearchResults}
                    noOptionsMessage={() => null}
                />
            </div>
        );
    }
}

export default SwapSearchForm;
